import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const COUNTRY_CODES = [
  "+1", "+44", "+33", "+49", "+39", "+34", "+81", "+86", "+91", "+61", "+55", "+7", "+27", "+234", "+251",
  "+20", "+52", "+82", "+966", "+971", "+972", "+31", "+46", "+41", "+90", "+351", "+30", "+48", "+63", "+84",
  "+66", "+60", "+62", "+65", "+64", "+353", "+45", "+47", "+358", "+420", "+36",
];

export interface PhoneInputProps {
  value: string;
  onChange: (value: string, countryCode: string) => void;
  selectedCountryCode?: string;
  id?: string;
}

/** A dialling code beside the number, both from the form kit. */
export function PhoneInput({ value, onChange, selectedCountryCode = "+1", id }: PhoneInputProps) {
  const codes = COUNTRY_CODES.includes(selectedCountryCode) ? COUNTRY_CODES : [selectedCountryCode, ...COUNTRY_CODES];
  return (
    <div className="flex gap-2">
      <Select value={selectedCountryCode} onValueChange={(code) => code && onChange(value, code)}>
        <SelectTrigger aria-label="Country code" className="w-24 shrink-0 tabular-nums">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {codes.map((code) => (
            <SelectItem key={code} value={code} className="tabular-nums">
              {code}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        id={id}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ""), selectedCountryCode)}
        placeholder="Phone number"
        className="tabular-nums"
      />
    </div>
  );
}
